export const drawOptions = {
  rectangle: false,
  polyline: false,
  polygon: true,
  circle: false,
  marker: false,
  circlemarker: false,
};

export enum ControlMapPosition {
  TopLeft = 'topleft',
  TopRight = 'topright',
  BottomLeft = 'bottomleft',
  BottomRight = 'bottomright',
}
